import { useState } from 'react'

import DataViewerTwoColoms from "../DataViewerTwoColoms/DataViewerTwoColoms";
import arrowDown from "../../assets/arrow-down-white.svg";
import "./style.css";

const AccordionButton = ({ title, data, background, icon }) => {
	const [visible, setVisible] = useState(false);

	return (
		<div className="accordion-button" style={{ background: background }}>
			<div className="accordion-button__header" style={{ backgroundColor: background }} onClick={() => setVisible((prev) => !prev)}>
				<div className="accordion-button__header-content">
					<img src={icon} alt="icon" />
					<p>{title}</p>
				</div>
				<img className="accordion-button__arrow" src={arrowDown} alt="Arrow" style={visible ? { rotate: "180deg" } : { rotate: "0deg" }} />
			</div>
			<div className={`accordion-button__content ${visible ? "visible" : ""}`}>
				<DataViewerTwoColoms data={data} />
			</div>
		</div>
	)
}

export default AccordionButton;
